import { Stack, Text } from '@chakra-ui/layout';
import { Flex, VStack } from '@chakra-ui/react';
import React from 'react';
import { FallbackProps } from 'react-error-boundary';

import StyledButton from '../../components/StyledButton';
import { useGlobalStateMachine } from '../../GlobalStore';
import { useEngeneNavigate } from '../../hooks/navigate';

// const ErrorFallback = (props: FallbackProps) => {
//   return (
//     <Stack minH={'100vh'} direction={{ base: 'column', md: 'row' }}>
//       <Flex p={8} flex={1} align={'center'} justify={'center'}>
//         <Stack direction="column" spacing={6} w={'full'} maxW={'lg'}>
//           <VStack backgroundColor="red.200" fontWeight="bold" width="100%">
//             <Text>エラーが発生しました</Text>
//             <VStack>
//               <Text>{props.error.name}</Text>
//               <Text>{props.error.message}</Text>
//             </VStack>
//           </VStack>
//           <Text>お手数ですがログインしなおしてください</Text>
//         </Stack>
//       </Flex>
//     </Stack>
//   );
// };
// export default ErrorFallback;

const ErrorFallback = (props: FallbackProps) => {
  const { actions } = useGlobalStateMachine();

  React.useState(() => actions.setGuard(false));

  return (
    <Stack minH={'100vh'} direction={{ base: 'column', md: 'row' }}>
      <Flex p={8} flex={1} align={'center'} justify={'center'}>
        <Stack direction="column" spacing={6} w={'full'} maxW={'lg'}>
          {/* <VStack backgroundColor="red.200" fontWeight="bold" width="100%">
            <Text>エラーが発生しました</Text>
            <VStack>
              <Text>{props.error.name}</Text>
              <Text>{props.error.message}</Text>
            </VStack>
          </VStack>
          <Text>お手数ですがログインしなおしてください</Text> */}
          <VStack backgroundColor="blue.200" width="100%">
            <Text>正常に処理を完了できませんでした({props.error.name})</Text>
            <VStack>
              <Text>お手数ですがログインし直してください。</Text>
            </VStack>
          </VStack>
          <StyledButton onClick={() => actions.logout()}>
            ログイン画面に戻る
          </StyledButton>
        </Stack>
      </Flex>
    </Stack>
  );
};
export default ErrorFallback;
